import InnerPageMusic from './innerPageMusic'
import TemplateMain from '../templateMain'
export default function PageMusic () {
  return (
    <TemplateMain
      g_section='music'
      htmlTitle='Music'
      linksTitle='Other Site Links'
      innerPage={<InnerPageMusic />}
      g_sidebarKey='pageMusic'
      g_slideshowKey=''
    />
  )
}
